/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/styles";
import {
  Grid,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Divider,
  Button,
} from "@material-ui/core";
import BottomBar from "../../../../components/BottomBar/BottomBar";
// import RadioButtonGroup from "../Chunks/RadioButtonGroup";
import CompleteDisputeOrderActionsSection from "./CompleteDisputeOrderActionsSection";
import {
  HttpRequest,
  HttpRequestFileDownload,
} from "../../../../utils/httpRequests";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 500,
    border: "1px solid " + theme.palette.common.white,
  },
  body: {
    fontSize: 14,
    //border: '1px solid '+theme.palette.primary.main,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.action.hover,
      border: "1px solid " + theme.palette.common.white,
    },
  },
}))(TableRow);
const useStyles = () => ({
  card: {
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
    //height: "100%",
    borderRadius: 10,
    // marginBottom: 40,
    // marginTop: 50,
  },
  image: {
    border: "1px solid #E1E1E1",
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: 350,
    width: "99%",
  },
  title: {
    color: "#3f51b5",
    display: "flex",
    fontSize: 20,
    marginTop: 5,
    width: "30%",
  },
  imgTitle: {
    fontWeight: 700,
    color: "#3f51b5",
  },
  titleIcon: {
    marginRight: 20,
    fontSize: 28,
  },
  titleDivider: {
    width: "93%",
    backgroundColor: "#3f51b5",
    opacity: "0.5",
    marginLeft: 15,
    marginBottom: 10,
  },
  cardContent: {
    flexGrow: 1,
    padding: 10,
    overflow: "auto",
  },
  imageContainer: {
    flexGrow: 1,
    margin: 10,
  },
  imagePageNo: {
    backgroundColor: "#d9d8d8",
    fontSize: 35,
    fontWeight: 600,
    marginRight: 4,
  },
});

class CompleteDisputedOrder extends React.Component {
  //  constructor(props) {
  //   super(props);

  //   //debugger;
  //   this.state = {
  //     orderDisputedItemsActionsData:[],
  //     disputededOrderId:props.values.DisputedOrdersData[0].orderId

  //   }

  //   console.log("ORDEER",props.values.DisputedOrdersData[0].orderId)
  //  }
  // componentDidMount() {
  //   this.getData(
  //     `/sales/C01SalesOrderDisputeItemsStatusesView`,
  //     "orderDisputedItemsActionsData",
  //     "orderDisputedItemsActionsDataLoading"
  //   );
  // }

  // componentDidUpdate() {
  //  this.getData(
  //     `/sales/C01SalesOrderDisputeItemsStatusesView`,
  //     "orderDisputedItemsActionsData",
  //     "orderDisputedItemsActionsDataLoading"
  //   );
  // }


  // getData = async (endpoint = "", stateName = "", loadingStateName = "") => {
  //     let resData = [];
  //     let data=new FormData();
  //     data.append("orderId",this.state.disputededOrderId)
  //     this.setState({
  //       [loadingStateName]: true,
  //     });
  //     const res = await HttpRequest(
  //       "GET",
  //       `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endpoint}`,
  //       data,
  //       "authorizeJson"
  //     );
  //     if (res.isSuccess) {
  //       resData = res.data || [];
  //     } else {
  //       if (res.statusCode === 401) {
  //         this.setState({
  //           isLoginMenu: true,
  //         });
  //       }
  //     }



  //     this.setState({
  //       orderDisputedItemsActionsData: resData,
  //       [loadingStateName]: false,
  //     });
  //   };

  render() {
    const { classes, values = {}, rows = {} } = this.props;

    console.log("Dispute values", this.props.rows)

    return (
      <React.Fragment>
        <Card className={classes.card}>
          {/* <Divider className={classes.titleDivider} /> */}
          <CardContent
            style={{
              overflow: "auto",
              minHeight: window.innerHeight - 124,
              maxHeight: window.innerHeight - 124,
              padding: 0,
            }}
          >
            <div className={classes.imageContainer}>
              {this.props.values.imagesDataLoading ? (
                <div>
                  <CircularProgress />
                </div>
              ) : (
                <Fragment>
                  {this.props.rows && this.props.rows.length > 0 && (
                    <>
                      <div style={{ width: "100%", marginBottom: 20 }}>
                        <div
                          style={{
                            display: "flex",
                            marginTop: 20,
                            marginBottom: 20,
                            fontSize: 20,
                            color: "#3f51b5",
                            fontWeight: 600,
                          }}
                        >
                          Dispute Order Details (Pre-Delivered)
                        </div>
                        <div
                          style={{
                            marginBottom: 14,
                            marginTop: "-15px",
                            color: `${this.props.rows[0].prePostDeliveredEnum == 1
                                ? "green"
                                : this.props.rows[0].prePostDeliveredEnum == 2
                                  ? "#ffbc00"
                                  : this.props.rows[0].prePostDeliveredEnum == 3
                                    ? "red"
                                    : "black"
                              }`,
                          }}
                        >
                          <b>{this.props.rows[0].prePostDeliveredEnumLabel}</b>
                        </div>
                        <TableContainer component={Paper}>
                          <Table
                            className={classes.table}
                            size="small"
                            aria-label="customized table"
                          >
                            <TableHead>
                              <TableRow>
                                <StyledTableCell
                                  align="left"
                                  style={{
                                    background: "rgb(163 159 151",
                                  }}
                                >
                                  Order #
                                </StyledTableCell>
                                <StyledTableCell
                                  align="left"
                                  style={{
                                    background: "rgb(163 159 151",
                                  }}
                                >
                                  Dispute #
                                </StyledTableCell>
                                <StyledTableCell
                                  align="left"
                                  style={{
                                    background: "rgb(163 159 151",
                                  }}
                                >
                                  Dispute Reason{" "}
                                </StyledTableCell>
                                <StyledTableCell
                                  align="left"
                                  style={{
                                    background: "rgb(163 159 151",
                                  }}
                                >
                                  Dispute Remarks{" "}
                                </StyledTableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              <StyledTableRow>
                                <StyledTableCell
                                  component="th"
                                  scope="row"
                                  align="left"
                                  style={{
                                    width: "10%",
                                    border: "1px solid #fff",
                                  }}
                                >
                                  {this.props.rows[0].orderId}
                                </StyledTableCell>
                                <StyledTableCell
                                  component="th"
                                  scope="row"
                                  align="left"
                                  style={{
                                    width: "10%",
                                    border: "1px solid #fff",
                                  }}
                                >
                                  {this.props.rows[0].disputedId}
                                </StyledTableCell>
                                <StyledTableCell
                                  component="th"
                                  scope="row"
                                  align="left"
                                  style={{
                                    width: "25%",
                                    border: "1px solid #fff",
                                  }}
                                >
                                  {this.props.rows[0].disputeReturnTypeLabel}
                                </StyledTableCell>
                                <StyledTableCell
                                  component="th"
                                  scope="row"
                                  align="left"
                                  style={{
                                    width: "25%",
                                    border: "1px solid #fff",
                                  }}
                                >
                                  {this.props.rows[0].disputedOrderRemarks}
                                </StyledTableCell>
                              </StyledTableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                        <TableContainer component={Paper}>
                          <Table
                            className={classes.table}
                            size="small"
                            aria-label="customized table"
                          >
                            <TableHead>
                              <TableRow>
                                <StyledTableCell
                                  align="left"
                                  style={{
                                    background: "rgb(163 159 151",
                                  }}
                                >
                                  Delivery Partner
                                </StyledTableCell>
                                <StyledTableCell
                                  align="left"
                                  style={{
                                    background: "rgb(163 159 151",
                                  }}
                                >
                                  Delivery CN #
                                </StyledTableCell>
                                <StyledTableCell
                                  align="left"
                                  style={{
                                    background: "rgb(163 159 151",
                                  }}
                                >
                                  Booking Date
                                </StyledTableCell>
                                <StyledTableCell
                                  align="left"
                                  style={{
                                    background: "rgb(163 159 151",
                                  }}
                                >
                                  Dispatch Date
                                </StyledTableCell>
                                <StyledTableCell
                                  align="left"
                                  style={{
                                    background: "rgb(163 159 151",
                                  }}
                                >
                                  Delivery Date
                                </StyledTableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              <StyledTableRow>
                                <StyledTableCell
                                  component="th"
                                  scope="row"
                                  align="left"
                                  style={{
                                    width: "10%",
                                    border: "1px solid #fff",
                                  }}
                                >
                                  {this.props.rows[0].deliveryPartnerLabel}
                                </StyledTableCell>
                                <StyledTableCell
                                  component="th"
                                  scope="row"
                                  align="left"
                                  style={{
                                    width: "10%",
                                    border: "1px solid #fff",
                                  }}
                                >
                                  {this.props.rows[0].consignmentNo}
                                </StyledTableCell>
                                <StyledTableCell
                                  component="th"
                                  scope="row"
                                  align="left"
                                  style={{
                                    width: "10%",
                                    border: "1px solid #fff",
                                  }}
                                >
                                  {this.props.rows[0].bookingDate}
                                </StyledTableCell>
                                <StyledTableCell
                                  component="th"
                                  scope="row"
                                  align="left"
                                  style={{
                                    width: "10%",
                                    border: "1px solid #fff",
                                  }}
                                >
                                  {this.props.rows[0].dispatchDate}
                                </StyledTableCell>
                                <StyledTableCell
                                  component="th"
                                  scope="row"
                                  align="left"
                                  style={{
                                    width: "10%",
                                    border: "1px solid #fff",
                                  }}
                                >
                                  {this.props.rows[0].deliveryDate}
                                </StyledTableCell>
                              </StyledTableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                        <Divider />
                        <div
                          style={{
                            display: "flex",
                            marginTop: 20,
                            fontSize: 20,
                            color: "#3f51b5",
                            fontWeight: 600,
                          }}
                        >
                          Dispute Order Items Details
                        </div>
                      </div>

                      {this.props.rows.map((rows) => {
                        { let index = this.props.rows.length }
                        return (
                          <Fragment key={rows.id}>
                            <div style={{ width: "100%" }}>
                              <TableContainer component={Paper}>
                                <Table
                                  className={classes.table}
                                  size="small"
                                  aria-label="customized table"
                                >
                                  <TableHead>
                                    <TableRow>
                                      <StyledTableCell
                                        align="left"
                                        style={{
                                          background: "rgb(163 159 151",
                                        }}
                                      >
                                        Ticket #
                                      </StyledTableCell>
                                      <StyledTableCell
                                        align="left"
                                        style={{
                                          background: "rgb(163 159 151",
                                        }}
                                      >
                                        Ticket Remarks{" "}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        align="left"
                                        style={{
                                          background: "rgb(163 159 151",
                                        }}
                                      >
                                        Job #
                                      </StyledTableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    <StyledTableRow>
                                      <StyledTableCell
                                        component="th"
                                        scope="row"
                                        align="left"
                                        style={{
                                          width: "10%",
                                          border: "1px solid #fff",
                                        }}
                                      >
                                        {rows.disputeItemId}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        component="th"
                                        scope="row"
                                        align="left"
                                        style={{
                                          width: "25%",
                                          border: "1px solid #fff",
                                        }}
                                      >
                                        {rows.disputeItemRemarks}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        component="th"
                                        scope="row"
                                        align="left"
                                        style={{
                                          width: "10%",
                                          border: "1px solid #fff",
                                        }}
                                      >
                                        {" "}
                                        {rows.id}
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                            <div style={{ width: "100%" }}>
                              <TableContainer component={Paper}>
                                <Table
                                  className={classes.table}
                                  size="small"
                                  aria-label="customized table"
                                >
                                  <TableHead>
                                    <TableRow>
                                      <StyledTableCell
                                        align="left"
                                        style={{
                                          background: "rgb(163 159 151",
                                        }}
                                      >
                                        Product{" "}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        align="left"
                                        style={{
                                          background: "rgb(163 159 151",
                                        }}
                                      >
                                        Size{" "}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        align="left"
                                        style={{
                                          background: "rgb(163 159 151",
                                        }}
                                      >
                                        Packaging{" "}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        align="left"
                                        style={{
                                          background: "rgb(163 159 151",
                                        }}
                                      >
                                        Thumbnail{" "}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        align="left"
                                        style={{
                                          background: "rgb(163 159 151",
                                        }}
                                      >
                                        Dispatch Thumbnail{" "}
                                      </StyledTableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    <StyledTableRow>
                                      <StyledTableCell
                                        component="th"
                                        scope="row"
                                        align="left"
                                        style={{
                                          width: "40%",
                                          borderColor: "#fff",
                                        }}
                                      >
                                        {rows.productLabel}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        component="th"
                                        scope="row"
                                        align="left"
                                        style={{
                                          width: "10%",
                                          borderColor: "#fff",
                                        }}
                                      >
                                        {rows.productSizeLabel}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        component="th"
                                        scope="row"
                                        align="left"
                                        style={{
                                          width: "10%",
                                          borderColor: "#fff",
                                        }}
                                      >
                                        <div style={{ textAlign: "left" }}>
                                          <img
                                            alt="img"
                                            style={{
                                              height: 115,
                                              width: 115,
                                              marginBottom: 5,
                                            }}
                                            src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${rows.productPackagingTypeAsset}`}
                                          />
                                        </div>
                                      </StyledTableCell>
                                      <StyledTableCell
                                        component="th"
                                        scope="row"
                                        align="left"
                                        style={{
                                          width: "10%",
                                          borderColor: "#fff",
                                        }}
                                      >
                                        <div
                                          style={{ textAlign: "left" }}
                                          onClick={() =>
                                            this.props.onImageClick(rows)
                                          }
                                        >
                                          <img
                                            alt="img"
                                            style={{
                                              height: 115,
                                              width:
                                                rows.productCategoryLabel ==
                                                  "Theme Mug" ||
                                                  rows.productCategoryLabel ==
                                                  "Themed Photobook" ||
                                                  rows.productCategoryLabel ==
                                                  "Custom Photobook"
                                                  ? 180
                                                  : 120,
                                              marginBottom: 5,
                                            }}
                                            src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${rows.firstImageFileName}`}
                                          />
                                        </div>
                                      </StyledTableCell>
                                      <StyledTableCell
                                        component="th"
                                        scope="row"
                                        align="left"
                                        style={{
                                          width: "10%",
                                          borderColor: "#fff",
                                        }}
                                      >
                                        <div style={{ textAlign: "left" }}>
                                          <img
                                            alt="img"
                                            style={{
                                              height: 115,
                                              width: 150,
                                              marginBottom: 5,
                                            }}
                                            src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${rows.dispatchedImage}`}
                                          />
                                        </div>
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                            <br />
                            <div
                              style={{
                                width: "100%",
                                marginBottom: "10px",
                                display:
                                  rows.isDisputeImagesAvaliable == 0
                                    ? "none"
                                    : "unset",
                              }}
                            >
                              <TableContainer component={Paper}>
                                <Table
                                  className={classes.table}
                                  size="small"
                                  aria-label="customized table"
                                >
                                  <TableHead>
                                    <TableRow>
                                      <StyledTableCell
                                        align="left"
                                        style={{
                                          background: "rgb(163 159 151",
                                        }}
                                      >
                                        User Dispute Thumbnail 1
                                      </StyledTableCell>
                                      <StyledTableCell
                                        align="left"
                                        style={{
                                          background: "rgb(163 159 151",
                                        }}
                                      >
                                        User Dispute Thumbnail 1
                                      </StyledTableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    <StyledTableRow>
                                      <StyledTableCell
                                        component="th"
                                        scope="row"
                                        align="center"
                                        style={{
                                          width: "25%",
                                          borderColor: "#fff",
                                        }}
                                      >
                                        <div style={{ textAlign: "center" }}>
                                          <img
                                            alt="img"
                                            style={{
                                              height: 115,
                                              width: 150,
                                              marginBottom: 5,
                                            }}
                                            src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${rows.thumbnail1}`}
                                          />
                                        </div>
                                      </StyledTableCell>
                                      <StyledTableCell
                                        component="th"
                                        scope="row"
                                        align="center"
                                        style={{
                                          width: "25%",
                                          borderColor: "#fff",
                                        }}
                                      >
                                        <div style={{ textAlign: "center" }}>
                                          <img
                                            alt="img"
                                            style={{
                                              height: 115,
                                              width: 150,
                                              marginBottom: 5,
                                            }}
                                            src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${rows.thumbnail2}`}
                                          />
                                        </div>
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>



                          </Fragment>

                        );
                      }






                      )}
                      {


                        (rows.length > 0 &&

                          (<Fragment>
                            <br />
                            <hr />
                            <br />
                            <div
                              style={{
                                display: "flex",
                                marginTop: 20,
                                marginBottom: 20,
                                fontSize: 20,
                                color: "#3f51b5",
                                fontWeight: 600,
                              }}
                            >
                              Dispute Order Action
                            </div>
                            <Grid
                              xs={12}
                              container
                              direction="row"
                              justifyContent="flex-start"
                              spacing={2}
                              style={{
                                display: "flex",
                                marginLeft: "2px",
                                marginTop: "1px",
                                marginBottom: "20px",
                              }}
                            >
                              <CompleteDisputeOrderActionsSection
                                key={rows[0].id}
                                rows={rows[0]}
                                state={values}
                                onDisputeHandleChange={(e) =>
                                  this.props.onDisputeHandleChange(e)
                                }
                                handleSnackbar={(open, msg, severity) =>
                                  this.props.handleSnackbar(open, msg, severity)
                                }
                              />
                            </Grid>
                          </Fragment>
                          )


                        )

                      }

                    </>
                  )}
                  <br />
                  <br />
                  <BottomBar
                    leftButtonHide
                    rightButtonText="Save & Update Order Status"
                    rightButtonDisable={
                      this.props.values.isActionTypeDisputeRetry == 6
                    }
                    rightButtonAction={() => this.props.saveDisputeStatus(0, 1)}
                    otherActions={
                      <>
                        {this.props.rows[0].disputeReturnTypeId == 6 &&
                          <Button
                            variant="contained"
                            color="default"
                            disabled={
                              this.props.rows[0].prePostDeliveredEnum != 0
                            }
                            onClick={() => this.props.saveDisputeStatus(1, 1)}
                            title={"Send Complete product to Dispatch Dashboard"}
                            style={{
                              textTransform: "capitalize",
                              marginRight: 10,
                            }}
                          >
                            Retry Delivery (Complete Product)
                          </Button>

                        }

                      </>
                    }
                  />
                </Fragment>
              )}
            </div>
          </CardContent>
        </Card>
      </React.Fragment>
    );
  }
}

CompleteDisputedOrder.propTypes = {
  classes: PropTypes.object,
  saveDisputeStatus: PropTypes.func,
  toggleChangeDisputedStatusDialog: PropTypes.func,
  rows: PropTypes.array,
  onImageClick: PropTypes.func,
  onDisputeHandleChange: PropTypes.func,
  values: PropTypes.object,
  handleSnackbar: PropTypes.func,
};

CompleteDisputedOrder.defaultProps = {
  classes: {},
  values: {},
  rows: [],
  onDisputeHandleChange: (fn) => fn,
  onImageClick: (fn) => fn,
  saveDisputeStatus: (fn) => fn,
  downloadPdfImagesData: (fn) => fn,
  toggleChangeDisputedStatusDialog: (fn) => fn,
  handleSnackbar: (fn) => fn,
};

export default withStyles(useStyles)(CompleteDisputedOrder);
